import React, { useEffect, useState } from 'react';
import { AppDispatch, useAppSelector } from '../../store';
import { fetchProjects, deleteProject } from '../../store/feature/projectSlice';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import BASE_URL from '../../constants/Config';

const ProjectList: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { projects, loading, totalCount, page, pageSize } = useAppSelector((state) => state.project);
  const token = localStorage.getItem('token') || '';

  const [currentPage, setCurrentPage] = useState(page || 1);
  const [itemsPerPage, setItemsPerPage] = useState(pageSize || 6);

  useEffect(() => {
    dispatch(fetchProjects({ page: currentPage, pageSize: itemsPerPage }));
  }, [dispatch, currentPage, itemsPerPage]);

  const handleDelete = (projectId: number) => {
    if (!token) {
      Swal.fire('Unauthorized', 'Proje silinirken bir sorun oluştu!', 'error');
      return;
    }
    Swal.fire({
      title: 'Emin misiniz?',
      text: 'Bu projeyi silmek istediğinizden emin misiniz?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Vazgeç',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteProject({ token, projectId }));
        Swal.fire('Silindi!', 'Proje başarıyla silindi.', 'success');
      }
    });
  };

  const getPhotoUrl = (filePath: string) => {
    const fileName = filePath.split('/').pop();
    return `${BASE_URL}/api/Project/photo/${fileName}`;
  };

  const truncateText = (text: string, maxLength: number) =>
    text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

  const totalPages = Math.ceil(totalCount / itemsPerPage);

  const handlePageChange = (pageNumber: number) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  if (loading) {
    return <p className="text-center text-gray-500">Projeler Yükleniyor...</p>;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-center mb-6">Proje Listesi</h1>

      <div className="flex justify-between items-center mb-4">
        <div>
          <label htmlFor="itemsPerPage" className="mr-2">Sayfa Boyutu:</label>
          <select
            id="itemsPerPage"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
            className="border rounded px-2 py-1"
          >
            <option value={6}>6</option>
            <option value={12}>12</option>
            <option value={18}>18</option>
          </select>
        </div>
        <p>Toplam {totalCount} Proje</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projects.map((project) => (
          <div
            className="bg-white shadow-md rounded-lg p-4 flex flex-col justify-between"
            key={project.id}
            style={{ height: '400px' }}
          >
            <div>
              <img
                src={getPhotoUrl(project.photoUrl)}
                alt={project.title}
                className="w-full h-48 object-cover rounded-md mb-4"
              />
              <h3 className="text-lg font-bold mb-2">{project.title}</h3>
              <p className="text-sm text-gray-600">
                {truncateText(project.content, 50)}
              </p>
            </div>
            <button
              onClick={() => handleDelete(project.id)}
              className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition duration-300 mt-4"
            >
              Sil
            </button>
          </div>
        ))}
      </div>

      <div className="flex justify-between items-center mt-6">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="bg-gray-500 text-white px-4 py-2 rounded disabled:bg-gray-300"
        >
          Geri
        </button>
        <p>Sayfa {currentPage} / {totalPages}</p>
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="bg-gray-500 text-white px-4 py-2 rounded disabled:bg-gray-300"
        >
          İleri
        </button>
      </div>
    </div>
  );
};

export default ProjectList;
